import { render, staticRenderFns } from "./BaseView.vue?vue&type=template&id=4c7ef9e7&scoped=true&"
import script from "./BaseView.vue?vue&type=script&lang=ts&"
export * from "./BaseView.vue?vue&type=script&lang=ts&"
import style0 from "./BaseView.vue?vue&type=style&index=0&id=4c7ef9e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7ef9e7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VChip,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle,VSkeletonLoader})
